import { createContext } from "react";

export const FloatingPanelContext = createContext<{
  container: HTMLDivElement | null;
  setOffset: (props: { block?: number; inline?: number }) => void;
}>({
  container: null,
  setOffset: ({}) => {},
});

export const FloatingPanelContextProvider = FloatingPanelContext.Provider;
